import { useEffect } from "react";

interface PageMeta {
  title: string;
  description: string;
  path: string;
}

function setMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function usePageMeta({ title, description, path }: PageMeta) {
  useEffect(() => {
    const basePath = __BASE_PATH__.split("/").filter(Boolean).join("/");
    const pathPrefix = basePath ? `/${basePath}` : "";
    const canonical = `${window.location.origin}${pathPrefix}${path}`;

    document.title = title;
    setMeta("name", "description", description);
    setMeta("name", "keywords", "韩漫,韩漫推荐,韩漫排行榜,人气韩漫,高分韩漫,韩漫大全");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:locale", "zh_CN");
    setMeta("property", "og:url", canonical);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);

    let canonicalLink = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute("href", canonical);
  }, [title, description, path]);
}